var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.term)?_c('span',[(_vm.term.color)?_c('div',{staticClass:"color-preview",style:({background: _vm.term.color})}):_vm._e(),_vm._v(" "+_vm._s(_vm.term.name)+" "),(_vm.currentUser.isDeveloper && _vm.term.id > 0)?_c('span',{staticClass:"term-text"},[_vm._v(" ("+_vm._s(_vm.$t('id'))+": "+_vm._s(_vm.term.id)+")")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }